import { z } from "zod";

export const followUserPayloadSchema = z.object({
  followerId: z.string().cuid(),
  followingId: z.string().cuid(),
});

export type FollowUserPayload = z.infer<typeof followUserPayloadSchema>;

export const followUserSchema = z.object({
  id: z.string().cuid(),
  name: z.string(),
  image: z.string().url().nullish(),
  createdAt: z.coerce.date(),
});

const followingUserSchema = z
  .object({
    following: followUserSchema.omit({ createdAt: true }),
    createdAt: z.coerce.date(),
  })
  .transform((data) => ({ ...data.following, createdAt: data.createdAt }));

const followerUserSchema = z
  .object({
    follower: followUserSchema.omit({ createdAt: true }),
    createdAt: z.coerce.date(),
  })
  .transform((data) => ({ ...data.follower, createdAt: data.createdAt }));

export const followingUsersSchema = z.array(followingUserSchema);
export const followerUsersSchema = z.array(followerUserSchema);

export type FollowUser = z.infer<typeof followUserSchema>;

export const partnerSocialLinksSchema = z.object({
  x: z.string().url().nullish(),
  discord: z.string().url().nullish(),
  telegram: z.string().url().nullish(),
  youtube: z.string().url().nullish(),
  github: z.string().url().nullish(),
  website: z.string().url().nullish(),
  instagram: z.string().url().nullish(),
  tiktok: z.string().url().nullish(),
  facebook: z.string().url().nullish(),
  snapchat: z.string().url().nullish(),
  linkedin: z.string().url().nullish(),
});

export const partnerSchema = z.object({
  id: z.string().cuid(),
  name: z.string(),
  description: z.string(),
  logoUrl: z.string().url(),
  coverImageUrl: z.string().url().nullish(),
  socialLinks: partnerSocialLinksSchema,
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deletedAt: z.coerce.date().nullish(),
});
